import gql from 'graphql-tag';

const LatestEnrolledProductsForOrgQuery = gql`
  query LatestEnrolledProductsForOrgQuery($thirdPartyOrganizationId: String!, $userId: String!, $limit: Int!) {
    ProgramCurriculumProductsV1Resource {
      latestEnrolledCourseActivitiesByThirdPartyOrganizationAndUser(
        thirdPartyOrganizationId: $thirdPartyOrganizationId
        userId: $userId
        limit: $limit
      ) {
        elements {
          id
          productItemId
          productType
          programId
        }
      }
    }
  }
`;

export default LatestEnrolledProductsForOrgQuery;
